export default {
    desc: "Description",
    sections: {
        meats: "Choose",
        side: "Choose a side",
        drinks: "Choose a drink",
        addOn: "Add on",
        ingredients: "Ingredients",
        quantity: "Quantity"
    },
    optional: "Optional",
    btnAddToBag: "Add to bag",
    priceLabel: "Price {0} baht",
    price: "Price",
    priceUnit: "baht",
    err_more_then_40: 'You cannot place more than 40 items per Order, Please make new Order to continue.'
}
